export default [
    {
        path: 'medicamento',
        component: () => import(
            /* webpackChunkName: 'cadastro-medicamento' */
            '@/views/cadastro/medicamento/Index'
        ),
        redirect: 'medicamento/index',
        children: [
            {
                name: 'cadastro-medicamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-medicamento' */
                    '@/views/cadastro/medicamento/List.vue'
                ),
            },
            {
                name: 'cadastro-medicamento-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-medicamento' */
                    '@/views/cadastro/medicamento/Form.vue'
                ),
            },
            {
                name: 'cadastro-medicamento-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-medicamento' */
                    '@/views/cadastro/medicamento/Form.vue'
                ),
            },
        ],
    },
]